import { Button, Result } from 'antd'
import { Link } from 'react-router-dom'

export function Page403 (): JSX.Element {
  return (
    <Result
      status='403'
      title='403'
      subTitle='Sorry, you do not have the permissions to access this page.'
      extra={
        <Link component={Button} type='primary' to='/'>
          Back Home
        </Link>
      }
    />
  )
}
